var map = {
	"./symbol_0.png": 77381,
	"./symbol_1.png": 43516,
	"./symbol_10.png": 66694,
	"./symbol_11.png": 48239,
	"./symbol_12.png": 26772,
	"./symbol_2.png": 48599,
	"./symbol_3.png": 58606,
	"./symbol_4.png": 41697,
	"./symbol_5.png": 68984,
	"./symbol_6.png": 43475,
	"./symbol_7.png": 92714,
	"./symbol_8.png": 69309,
	"./symbol_9.png": 48180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88088;